import { createContext, createTaggedStateHook } from "@tagged-state/react";
import { type FaceTecSDKInstance } from "facetec-sdk";
import { State } from "../useManageFaceTecInstance";

export type { State };

const { Context, ComponentGuard } = createContext<State>({
  tag: "uninit",
  data: {},
});

const useReadyFaceTecInstance = createTaggedStateHook(
  Context,
  "ready" as const,
);

export const FaceTecInstanceContext = Context;
export const FaceTecInstanceGuard = ComponentGuard;

// Throws if the instance is not ready.
export const useFaceTecInstance = (): FaceTecSDKInstance =>
  useReadyFaceTecInstance().instance;
